/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {LoadingService} from '../loading/loading-service/loading.service';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {ErrorPageEnum} from './error-page.enum';
import {ErrorPageModel} from './error-page.model';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorPageComponent implements OnInit, OnDestroy {
    public subscriptions = new Subscription();
    public pageInformation: ErrorPageModel;
    public errorType: ErrorPageEnum;
    public readonly errors = new Map<ErrorPageEnum, ErrorPageModel>([
        [ErrorPageEnum.FORBIDDEN, {
            title: 'Forbidden',
            subtitle: 'Access is allowed only for specific users',
            icon: 'iwp-icon-gen_locked'
        }]
    ]);

    constructor(private loadingService: LoadingService, private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.subscriptions.add(this.route.queryParams.subscribe(queryParams => {
            this.errorType = queryParams.errorType;
            this.pageInformation = this.errors.get(this.errorType);
        }));
        this.loadingService.stop();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
